import {FC, memo, useEffect} from 'react'
import {useStoreActions, useStoreState} from '@/store'
import NearbyLocations from '@/components/NearbyLocations'
import generics from "@/utils/generics";

const NoSearchResults: FC = () => {
    const { results, queryResponse, locationsNearbyResponse, embedded } = useStoreState(
        state => state.search
    )

    const { onProductListViewedTracking } = useStoreActions(actions => actions.tracking)

    const closestLocation = locationsNearbyResponse?.nearby_locations?.[0]?.distance_in_miles

    useEffect(() => {
        const initalProductListViewedPayload =
            generics.buildProductListViewedPayload(results)

        onProductListViewedTracking(initalProductListViewedPayload)
    }, [queryResponse])

  return (
    <>
      <div
        className="p-6 shadow-sm rounded bg-gray-100"
        data-testid="no-agents-found"
      >
        <h4 className="mb-2">
          We&#39;re sorry, Bankrate doesn&#39;t currently have coverage in your local area.
        </h4>
        {locationsNearbyResponse?.nearby_locations.length ? 
        <div>
          {closestLocation > 200 ? <p className="mb-0 text-base">
            Here are the closest areas we do have agents.
          </p> :  <p className="mb-0 text-base">
            Here are some nearby areas we do have coverage.
          </p>}
        </div> 
        : 
        <p className="mb-0 text-base">
          Try modifying your search by resetting one or more filters.
        </p>
        }
      </div>
      <NearbyLocations showHeading={false} hideOnNoResults={false}/>
    </>
  )
}

export default memo(NoSearchResults)
